var base = require('auth/register-braintree');

Vue.component('spark-register-braintree', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/auth/register-braintree.js